import React, { useState, useEffect, useMemo, useRef } from "react";

import Navbar from "../../components/Navbar";
import PageContent from "../../components/PageContent";
import Header from "../../components/Header";
import CustomModal from "../../components/CustomModal";

import "./styles.css";

import { ReactComponent as SelectItemsSVG } from "../../assets/Select-amico.svg";
import { ReactComponent as MobilePhone } from "../../assets/mockups/workout-screen.svg";
import { ReactComponent as LogoSVG } from "../../assets/logo/M_WHITE_LOGO_FULL.svg";

import {
  Snackbar,
  Chip,
  Switch,
  Typography,
  Select,
  CircularProgress,
  Button,
  MenuItem,
  IconButton,
  Tooltip,
  TextField,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import SendIcon from "@mui/icons-material/Send";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import MarkUnreadChatAltIcon from "@mui/icons-material/MarkUnreadChatAlt";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import PushPinIcon from "@mui/icons-material/PushPin";

import Popper from "@mui/material/Popper";
import Slider from "@mui/material/Slider";
import Alert from "@mui/material/Alert";
import Divider from "@mui/material/Divider";
import FemaleIcon from "@mui/icons-material/Female";
import MaleIcon from "@mui/icons-material/Male";

import Draggable from "react-draggable";

import api from "../../helpers/api.js";

import {
  DragDropContext,
  Droppable,
  Draggable as DraggableComponent,
} from "react-beautiful-dnd";

import { useNavigate, useLocation } from "react-router-dom";

import { WorkoutHelpers as WH } from "./WorkoutHelpers.js";

const filters = [
  {
    key: "libraryWorkoutGender",
    name: "Gênero",
    options: [
      {
        label: "Masculino",
        value: "MALE",
        icon: <MaleIcon />,
      },
      {
        label: "Feminino",
        value: "FEMALE",
        icon: <FemaleIcon />,
      },
    ],
  },
  {
    key: "libraryWorkoutAmbient",
    name: "Ambiente",
    options: [
      {
        label: "Academia",
        value: "GYM",
      },
      {
        label: "Em casa",
        value: "HOME",
      },
    ],
  },
  {
    key: "libraryWorkoutDifficulty",
    name: "Dificuldade",
    options: [
      {
        label: 1,
        value: "BEGINNER",
      },
      {
        label: 2,
        value: "INTERMEDIATE",
      },
      {
        label: 3,
        value: "ADVANCED",
      },
    ],
  },
  {
    key: "libraryWorkoutAgeGroup",
    name: "Faixa etária",
    options: [
      {
        label: "Até 25 anos",
        value: "25",
      },
      {
        label: "De 26 a 40 anos",
        value: "40",
      },
      {
        label: "De 41 a 60 anos",
        value: "60",
      },
      {
        label: "60 anos ou mais",
        value: "80",
      },
    ],
  },
  {
    key: "libraryWorkoutGoal",
    name: "Objetivo principal",
    options: [
      {
        label: "Estética",
        value: "AESTHETICS",
      },
      {
        label: "Saúde",
        value: "HEALTH",
      },
      {
        label: "Ganho de massa",
        value: "MUSCLE_MASS",
      },
      {
        label: "Força",
        value: "STRENGTH",
      },
      {
        label: "Emagrecimento",
        value: "FAT_LOSS",
      },
    ],
  },
];

const Conf = {
  //Variável com os dados do treino
  workout: {
    cpf: null,
    name: "",
    description: "",
    goal: "Estética",
    workout_focus: "NOT_SPECIFIED",
    banner: "https://assets.ginastee.com/workouts/OfI1Xd39Vh.png",
    exercises_for_each_day: [[]],
  },

  currentTab: 0,
  commonPatterns: {
    series: WH.getPattern("series") || 3,
    repetitions: WH.getPattern("repetitions") || 10,
    restTime: WH.getPattern("restTime") || 45,
  },

  resetParameters() {
    Conf.workout.exercises_for_each_day = [[]];
    Conf.currentTab = 0;
    Conf.name = "";
    Conf.description = "";
    Conf.triggerExerciseListChange()
  },

  triggerSnackbar(v) {
    WH.triggerDefaultEvent("snack_message", v);
  },
  onSnackbarTriggered(callback) {
    window.addEventListener("snack_message", (e) => {
      callback(e.detail);
    });
  },

  triggerWorkoutLoaded(v) {
    Conf.workout = { ...Conf.workout, ...v };
    WH.triggerDefaultEvent("workout_loaded", v);
  },
  onLoadedWorkout(callback) {
    window.addEventListener("workout_loaded", (e) => {
      callback(e.detail);
    });
  },

  triggerExercisesUpdated(v) {
    WH.triggerDefaultEvent("exercises_updated", v);
  },
  onExerciseUpdated(callback) {
    window.addEventListener("exercises_updated", (e) => {
      callback(e.detail);
    });
  },

  /* ====================================================== */
  // Eventos da aba atual
  triggerAddTab(v) {
    Conf.workout.exercises_for_each_day.push([]);
    Conf.triggerTabChange(Conf.workout.exercises_for_each_day.length - 1);
    WH.triggerDefaultEvent("tab_added", v);
  },
  onTabAdded(callback) {
    window.addEventListener("tab_added", (e) => {
      callback(e.detail);
    });
  },
  triggerTabRemove(tabIndex) {
    Conf.workout.exercises_for_each_day.splice(tabIndex, 1);
    Conf.triggerTabChange(0);
    WH.triggerDefaultEvent("tab_removed", tabIndex);
  },
  onTabRemove(callback) {
    window.addEventListener("tab_removed", (e) => {
      callback(e.detail);
    });
  },
  triggerTabChange(v) {
    Conf.currentTab = v;
    WH.triggerDefaultEvent("tab_change", v);
  },
  onTabChange(callback) {
    window.addEventListener("tab_change", (e) => {
      callback(e.detail);
    });
  },

  triggerExerciseListChange(v) {
    WH.triggerDefaultEvent("exercise_list_change", v);
  },
  onExerciseListChange(callback) {
    window.addEventListener("exercise_list_change", (e) => {
      callback(e.detail);
    });
  },

  getCurrentTabExercises() {
    return Conf.getDays()[Conf.currentTab];
  },
  getDays() {
    return Conf.workout.exercises_for_each_day;
  },

  updateParameterInAllExercises(key, value) {
    Conf.workout.exercises_for_each_day[Conf.currentTab] =
      Conf.getCurrentTabExercises().map((exercise) => {
        if (exercise.isGroup) {
          exercise.exercises = exercise.exercises.map((groupExercise) => {
            groupExercise[key] = value;
            return groupExercise;
          });
          return exercise;
        } else {
          exercise[key] = value;
          return exercise;
        }
      });
    Conf.triggerExerciseListChange(Conf.workout);
  },
};

export default function CreateWorkout() {
  document.title = "Criar treino | Ginastee";

  const lastAddedIndex = useRef();

  const [loading, setLoading] = useState(true);
  const [creatingWorkoutLoading, setCreatingWorkoutLoading] = useState(false);
  const [loadingExistingWorkout, setLoadingExistingWorkout] = useState(true);

  const [exercisesAvailable, setExercisesAvailable] = useState([]);

  const [modalAddCommentOpenFor, setModalAddCommentOpenFor] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = useLocation();

  const customerParams = location?.state;
  Conf.customerParams = {...customerParams};
  Conf.workout.cpf = customerParams.cpf;
  const mode = location?.state?.mode;
  const isInLibraryMode = mode === "LIBRARY_WORKOUT";
  const isCreatingNewLibraryWorkout = !!location.state.createNewModel;
  const preLoadedWorkout = location?.state?.preLoadedWorkout;

  console.log(customerParams)

  const [filtersState, setFiltersState] = useState(getFilters());


  useEffect(() => {
    if (loading) {
      loadExercises();
    }
  }, [loading]);

  useEffect(() => {
    Conf.resetParameters();
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 10);
  }, [pathname]);

  async function handleCreateWorkout() {
    console.log(Conf.workout);

    if (Conf.workout.validUntil < 2) {
      Conf.triggerSnackbar(
        "A ficha de treinos tem uma validade, e ela deve ser maior do que 1 " +
          (Conf.workout.validityType === "QTD" ? "treino" : "dia")
      );

      return;
    }

    const hasADayWithLessThanOneExercise = getExercisesPerDayValidation();
    if (hasADayWithLessThanOneExercise.length > 0) {
      Conf.triggerSnackbar(
        "Você precisa selecionar dois ou mais exercícios no dia " +
          (hasADayWithLessThanOneExercise[0] + 1)
      );
      Conf.setCurrentTab(hasADayWithLessThanOneExercise[0]);
      return;
    }

    if (Conf.workout.description.length >= 800) {
      Conf.triggerSnackbar(
        "Você só pode adicionar no máximo 800 caracteres na descrição da ficha"
      );
      return;
    }

    const hasAnExerciseWithBlankParameter = getBlankParameterValidation();
    if (hasAnExerciseWithBlankParameter.length > 0) {
      Conf.triggerSnackbar(
        "O número de repetições e séries do dia " +
          (hasAnExerciseWithBlankParameter[0] + 1) +
          " devem ser maiores ou iguais a 0"
      );
      Conf.setCurrentTab(hasAnExerciseWithBlankParameter[0]);
      return;
    }

    if (Conf.workout.exercises_for_each_day.length < 1) {
      Conf.triggerSnackbar("Sua ficha de treinos deve ter dois dias ou mais");
      return;
    }

    if (Conf.workout.name.length < 2) {
      Conf.triggerSnackbar("Insira o nome do treino");
      return;
    }

    const workoutFormatted = workoutFactory(Conf.getDays());


    try {
      setCreatingWorkoutLoading(true);
      let creationResult;

      //O treino de algum usuário está sendo ATUALIZADO
      if (customerParams.action === "edit") {
        creationResult = await api.patch("/gym/workouts", {
          ...workoutFormatted,
          id: customerParams.workoutId,
        });
      }
      //Um treino está sendo criado para a biblioteca
      else if (isCreatingNewLibraryWorkout) {
        const categories = {
          difficulty: filtersState.libraryWorkoutDifficulty || "GENERIC",
          ambient: filtersState.libraryWorkoutAmbient || "GYM",
          goal: filtersState.libraryWorkoutGoal || "HEALTH",
          age_group: filtersState.libraryWorkoutAgeGroup || "GENERIC",
          gender: filtersState.libraryWorkoutGender || "GENERIC",
        };

        creationResult = await api.post("/gym/workouts/library", {
          ...workoutFormatted,
          ...categories,
        });
      }
      //Um treino está sendo CRIADO
      else {
        creationResult = await api.post("/gym/workouts", {
          ...workoutFormatted,
          targetUserId: customerParams.id,
        });
      }

      creationResult = creationResult.data;

      if (creationResult[0]) {
        Conf.triggerSnackbar(
          customerParams.action === "edit"
            ? "Treino atualizado com sucesso"
            : "O treino foi criado com sucesso"
        );
        setTimeout(() => {
          navigate(-1);
        }, 2000);
        return;
      } else {
        Conf.triggerSnackbar(
          "Houve um erro na criação do treino, por favor tente mais tarde"
        );
      }

      setCreatingWorkoutLoading(false);
    } catch (e) {
      console.log(e);
      setCreatingWorkoutLoading(false);
      Conf.triggerSnackbar(
        "Houve um erro na criação do treino, por favor tente mais tarde"
      );
    }
    function workoutFactory(data) {
      let workoutExercises = [...data].map((dayExercises) => {
        let exercises = [];

        let groupIndex = 0;
        for (let i = 0; i < dayExercises.length; i++) {
          if (dayExercises[i].isGroup) {
            dayExercises[i].exercises.forEach((e) =>
              exercises.push({ ...e, group: groupIndex })
            );
            groupIndex += 1;
          } else {
            exercises.push(dayExercises[i]);
          }
        }

        return exercises.map((exercise) => {
          return {
            id: exercise.ExerciseID,
            series: parseInt(exercise.series),
            rest_time: parseInt(exercise.restTime),
            execution_quantity: parseInt(exercise.repetitions),
            execution_type: "REPETITIONS",
            cadence: 2,
            comment: exercise.comment,
            group: exercise.group,
          };
        });
      });
      const creationPayload = {
        cpf: customerParams.cpf,
        name: Conf.workout.name,
        description: Conf.workout.description,
        goal: "Estética",
        workout_focus: "NOT_SPECIFIED",
        banner: "https://assets.ginastee.com/workouts/OfI1Xd39Vh.png",
        exercises_for_each_day: workoutExercises,
      };

      if (Conf.workout.validUntil) {
        creationPayload[
          Conf.workout.validityType === "QTD"
            ? "valid_until_executions"
            : "valid_until_days"
        ] = Conf.workout.validUntil;
      }

      return creationPayload;
    }
    function getExercisesPerDayValidation() {
      return Conf.getDays()
        .map((day, i) => (day.length <= 1 ? i : null))
        .filter((el) => el !== null);
    }

    function getBlankParameterValidation() {
      return Conf.getDays()
        .map((day, i) => {
          return day
            .map((exercise) => {
              exercise.repetitions = parseInt(exercise.repetitions);
              exercise.series = parseInt(exercise.series);
              return !!(exercise.repetitions < 1 || exercise.series < 1);
            })
            .filter((el) => el === true).length > 0
            ? i
            : null;
        })
        .filter((el) => el !== null);
    }
  }
  function getFilters() {
    const result = {};
    filters.forEach((filter) => (result[filter.key] = false));
    return result;
  }
  async function handleFillCreatedWorkout() {
    try {
      let loadedWorkout;

      console.log(customerParams)

      if (preLoadedWorkout) {
        loadedWorkout = preLoadedWorkout;
      } else {
        loadedWorkout = await api.get(
          "/gym/workouts?id=" + customerParams.workoutId
        );
        loadedWorkout = loadedWorkout.data[customerParams.workoutId];
      }

      const description = loadedWorkout.description || "";
      const title = loadedWorkout.name;

      Conf.triggerWorkoutLoaded({
        name: title,
        description,
        exercises_for_each_day: getWorkoutExercises(loadedWorkout.workoutDays),
      });
    } catch (e) {
      console.log("Erro ao carregar treino");
      console.log(e);
    }

    function getWorkoutExercises(data) {
      return [...data].map((dayConfig) => {
        const workoutExercisesMounted = [];
        let tmpExercise = {};

        console.log(dayConfig);

        const groups = dayConfig.filter((e) => e.group !== null);
        let groupExercises = [];

        groups.forEach((exercise) => {
          if (!groupExercises[exercise.group])
            groupExercises[exercise.group] = [];
          groupExercises[exercise.group].push(exercise);
        });

        const uniqueArray = dayConfig.filter((obj, index, self) => {
          if (obj.group === null) {
            return true;
          }
          return index === self.findIndex((o) => o.group === obj.group);
        });

        for (let i = 0; i < uniqueArray.length; i++) {
          tmpExercise = formatExercise(uniqueArray[i]);

          if (tmpExercise.group !== null) {
            workoutExercisesMounted[i] = {
              isGroup: true,
              exercises: groupExercises[tmpExercise.group].map((exercise) =>
                formatExercise(exercise)
              ),
            };
          } else {
            workoutExercisesMounted.push(tmpExercise);
          }
        }

        return workoutExercisesMounted;

        function formatExercise(exercise) {
          return {
            ExerciseID: exercise.id,
            series: exercise.series,
            restTime: exercise.restTime,
            repetitions: exercise.executionQuantity,
            key: Math.random() * 100,
            MuscleGroups: exercise.muscleGroups.split(","),
            ExerciseName: exercise.name,
            BannerURL: exercise.bannerUrl,
            group: exercise.group,
            comment: exercise.comment,
          };
        }
      });
    }
  }

  async function loadExercises() {
    try {
      const route =
        mode === "LIBRARY_WORKOUT"
          ? "/gym/exercises"
          : "/gym/exercisesWithReactions?customerId=" + customerParams.id;

      let exercisesData = await api.get(route);

      exercisesData = exercisesData.data;

      if (exercisesData[0]) {
        exercisesData = exercisesData.map((exercise) => {
          exercise.displayInSelectFilter = true;
          exercise.MuscleGroups = exercise.MuscleGroups?.split(",") || [];
          return exercise;
        });
        setExercisesAvailable(exercisesData);

        if (customerParams.action === "edit" || preLoadedWorkout) {
          await handleFillCreatedWorkout();
        }
      }

      setLoading(false);
      setTimeout(() => {
        setLoadingExistingWorkout(false);
      }, 1);
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  }

  function openAddCommentModal(exerciseIndex, groupIndex) {
    const modalData = {
      exerciseIndex,
      groupIndex,
      existingComment: getExistingComment(),
    };
    setModalAddCommentOpenFor({ ...modalData });

    function getExistingComment() {
      if (groupIndex === null) {
        return Conf.getCurrentTabExercises()[exerciseIndex].comment;
      } else {
        return Conf.getCurrentTabExercises()[groupIndex].exercises[
          exerciseIndex
        ].comment;
      }
    }
  }
  function handleAddComment(comment) {
    const exercisesClone = [...Conf.getDays()];
    const exerciseIndex = modalAddCommentOpenFor.exerciseIndex;
    const groupIndex = modalAddCommentOpenFor.groupIndex;

    if (groupIndex === null) {
      exercisesClone[Conf.currentTab][exerciseIndex] = {
        ...exercisesClone[Conf.currentTab][exerciseIndex],
        comment,
      };
    } else {
      exercisesClone[Conf.currentTab][groupIndex].exercises[exerciseIndex] = {
        ...exercisesClone[Conf.currentTab][groupIndex].exercises[exerciseIndex],
        comment,
      };
    }

    Conf.workout.exercises_for_each_day = [...exercisesClone];
    Conf.triggerExerciseListChange();
    setModalAddCommentOpenFor(null);
  }

  return (
    <div className="page-area">
      <Navbar />

      {loadingExistingWorkout && (
        <LoadingWorkoutComponent navigate={navigate} />
      )}

      <PageContent page="nw">
        <HeaderContainer libraryMode={isCreatingNewLibraryWorkout} />

        <div className="top-settings">
          <div>
            <TopInputs />

            <GeneralExercisesConfig />

            <WorkoutValidUntilArea />
          </div>
          <Divider orientation="vertical" flexItem />
          <div>
            {isInLibraryMode ? (
              <>
                <Typography
                  variant="h3"
                  component="h3"
                  className="mt-2  mb-2 fade"
                >
                  Configurar categorias
                </Typography>
                <div id="list-filters">
                  {Object.keys(filters).map((filter) => (
                    <div className="list-filter-group-area">
                      <Typography variant="h5">
                        {filters[filter].name}
                      </Typography>
                      <div className="list-filter-group mt-1">
                        {filters[filter].options.map((option, i) => {
                          const key = filters[filter].key;
                          const active = filtersState[key] === option.value;
                          const inactive =
                            filtersState[key] &&
                            filtersState[key] !== option.value;
                          return (
                            <>
                              <Button
                                variant={"text"}
                                size="small"
                                className={
                                  "btn " + (active ? "active-btn" : "")
                                }
                                startIcon={option.icon}
                                style={{
                                  opacity: inactive ? 0.5 : 1,
                                }}
                                onClick={() => {
                                  setFiltersState({
                                    ...filtersState,
                                    [key]: active ? undefined : option.value,
                                  });
                                }}
                              >
                                {option.label}
                              </Button>
                              {i < filters[filter].options.length - 1 && (
                                <Divider
                                  style={{
                                    marginTop: "6px",
                                    marginBottom: "6px",
                                  }}
                                  orientation="vertical"
                                  flexItem
                                />
                              )}
                            </>
                          );
                        })}
                      </div>
                    </div>
                  ))}
                </div>
              </>
            ) : (
               <WorkoutMobilePhone />
            )}
          </div>
        </div>
        <div className="top-config-area"></div>
        <WorkoutDaysTab />
        <div className="exercises-section pb-9">
          <SelectExercises
            exercisesAvailable={exercisesAvailable}
            setExercisesAvailable={setExercisesAvailable}
          />
          <ConfigureExercises handleClickOnAddComment={openAddCommentModal} />
        </div>
        <Button
          variant="contained"
          onClick={handleCreateWorkout}
          color="secondary"
          sx={{ mt: 2 }}
          startIcon={creatingWorkoutLoading ? null : <SendIcon />}
          type="submit"
          style={{ animationDelay: "0.4s" }}
          className="fade create-workout-btn"
          disabled={creatingWorkoutLoading}
        >
          {creatingWorkoutLoading ? (
            <CircularProgress style={{ width: 26, height: 26 }} />
          ) : (
            <div>
              {customerParams.action === "edit"
                ? "Publicar alterações"
                : isCreatingNewLibraryWorkout
                ? "Criar template"
                : "Criar e enviar o treino"}
            </div>
          )}
        </Button>
      </PageContent>

      <ModalAddComment
        key={Math.random()}
        open={!!modalAddCommentOpenFor}
        setOpen={setModalAddCommentOpenFor}
        handleAddComment={handleAddComment}
        existingComment={modalAddCommentOpenFor?.existingComment}
      />
    </div>
  );
}

const TopInputs = () => {
  const REF_initialized = useRef(false);

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (!REF_initialized.current) {
      REF_initialized.current = true;
      Conf.onLoadedWorkout((data) => {
        if (data) {
          setName(data.name);
          setDescription(data.description);
        }
      });
    }
  }, []);

  useEffect(() => {
    Conf.workout.name = name;
  }, [name]);
  useEffect(() => {
    Conf.workout.description = description;
  }, [description]);

  return (
    <div className="top-inputs slide-right-fade delay-1">
      <Typography variant="h3" component="h3" className="mt-2  mb-2 fade">
        Informações gerais
      </Typography>
      <TextField
        size="medium"
        color="secondary"
        label="Nome da ficha"
        className="mt-1"
        onInput={(e) => setName(e.target.value)}
        value={name}
        variant="filled"
        inputProps={{
          autoComplete: "off",
          form: {
            autoComplete: "off",
          },
        }}
      />
      <TextField
        size="medium"
        color="secondary"
        label="Descrição (opcional)"
        inputProps={{ maxLength: 100 }}
        multiline
        error={description.length >= 800}
        value={description}
        helperText={`${description.length}/800`}
        className="mt-1 description-field"
        onInput={(e) => setDescription(e.target.value)}
        variant="filled"
        InputProps={{
          autoComplete: "off",
          form: {
            autoComplete: "off",
          },
        }}
      />
    </div>
  );
};

const HeaderContainer = ({ libraryMode = false }) => {
  const { name } = Conf.customerParams;
  const navigate = useNavigate();

  const title = libraryMode
    ? "Criar novo template"
    : `Enviar treino para ${name.split(" ")[0]}`;

  return (
    <>
      <Snack />

      <Header />

      <div>
        <div className="title-area mt-4 mb-5">
          <IconButton onClick={() => navigate(-1)}>
            <ArrowBackIosIcon />
          </IconButton>
          <Typography variant="h3" component="h3" className="left-border">
            {title}
          </Typography>
        </div>
      </div>
    </>
  );
};

const Snack = () => {
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const REF_eventSet = useRef(false);

  useEffect(() => {
    setTimeout(() => {
      setSnackbarMessage("");
    }, 5000);
  }, [snackbarMessage]);

  if (!REF_eventSet.current) {
    REF_eventSet.current = true;
    Conf.onSnackbarTriggered(setSnackbarMessage);
  }

  return (
    <Snackbar
      open={!!snackbarMessage}
      autoHideDuration={6000}
      onClose={() => setSnackbarMessage(null)}
      message={snackbarMessage}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    />
  );
};

const LoadingWorkoutComponent = ({ navigate }) => {
  const [message, setMessage] = useState("Carregando exercícios...");

  useEffect(() => {
    setTimeout(() => {
      setMessage("Montando a ficha");
    }, 1000);
  }, []);

  return (
    <div className="loading-overlay">
      <CircularProgress color="secondary" />
      <Typography variant="h3" className="mt-2">
        {message}
      </Typography>
      <Button
        variant="contained"
        onClick={() => navigate(-1)}
        color="secondary"
        size="small"
        className="mt-4"
      >
        Cancelar
      </Button>
    </div>
  );
};

const WorkoutMobilePhone = ({
}) => {
  const [name, setName] = useState()
  const [description, setDescription] = useState()
  const [config, setConfig] = useState([])
  const [currentTab, setCurrentTab] = useState()

  const REF_configured = useRef(false)


  useEffect(() => {
    if(!REF_configured.current){
      REF_configured.current = true

      Conf.onLoadedWorkout(refreshParameters)
      Conf.onExerciseListChange(refreshParameters)
      Conf.onTabChange(refreshParameters)
    }
  }, [])

  function refreshParameters(){
    setConfig([...Conf.getDays()])
    setCurrentTab(Conf.currentTab)
    setName(Conf.workout.name)
    setDescription(Conf.workout.description)
  }



  const Exercise = ({ data }) => (
    <div className="exercise-mobile">
      <img src={data.BannerURL} className="banner-exercise" />
      <div className="exercise-info">
        <Typography variant="p" component="p" className="exercise-title">
          {data.ExerciseName}
        </Typography>
        <div className="muscle-groups-area">
          {data.MuscleGroups?.map((muscleGroup, i) => (
            <Chip
              key={i + 1}
              size="small"
              label={muscleGroup}
              className="chip"
            />
          ))}
        </div>
      </div>
    </div>
  );

  return (
    <div className="mp">
      <div className="phone-content-section">
        <MobilePhone className="mobile-phone-mockup" />
        <div className="phone-content">
          <div className="phone-header">
            <IconButton className="phone-btn-return">
              <ArrowBackIosIcon />
            </IconButton>
            <LogoSVG className="phone-logo" />
          </div>
          <div className="mt-2 workout-phone-description">
            <Typography variant="p" component="p">
              {name || "Nome da ficha"}
            </Typography>
            <Typography
              variant="label"
              component="label"
              className="workout-description"
            >
              {description}
            </Typography>
          </div>
          <div className="days-tab mt-2">
            {config.map((dayConfig, index) => (
              <button
                key={index}
                className={
                  "day-tab " + (currentTab === index ? "active-tab" : "")
                }
              >
                <Typography
                  variant="label"
                  component="label"
                  className="workout-description"
                >
                  Dia {index + 1}
                </Typography>
              </button>
            ))}
          </div>
          <div className="exercises-list">
            {config[currentTab]?.length === 0 ? (
              <>
                <SelectItemsSVG />
                <Typography
                  variant="p"
                  component="label"
                  style={{ textAlign: "center" }}
                >
                  Selecione os exercícios para ver o preview
                </Typography>
              </>
            ) : (
              config[currentTab]?.map((exercise, index) => {
                if (exercise.isGroup) {
                  const uniqueExercises = exercise.exercises.filter(
                    (obj, index, self) => {
                      return (
                        index ===
                        self.findIndex(
                          (o) => o.ExerciseName === obj.ExerciseName
                        )
                      );
                    }
                  );
                  return (
                    <div className="group-preview">
                      {uniqueExercises.map((e, i) => (
                        <Exercise data={e} key={`${index}-${i}`} />
                      ))}
                    </div>
                  );
                }
                return <Exercise data={exercise} key={index} />;
              })
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const GeneralExercisesConfig = () => {
  const settings = [
    {
      name: "Repetições",
      key: "repetitions",
      step: 1,
      min: 1,
      max: 30,
    },
    {
      name: "Descanso (s)",
      key: "restTime",
      step: 5,
      min: 0,
      max: 150,
    },
    {
      name: "Séries",
      key: "series",
      step: 1,
      min: 1,
      max: 10,
    },
  ];

  const [values, setValues] = useState({
    repetitions: Conf.commonPatterns.repetitions,
    restTime: Conf.commonPatterns.restTime,
    series: Conf.commonPatterns.series,
  });

  function handleUpdateCommonPattern(value, attribute) {
    Conf.updateParameterInAllExercises(attribute, value);
    Conf.commonPatterns[attribute] = value;
    localStorage.setItem(`common-${attribute}`, value);
    setValues({ ...values, [attribute]: value });
  }

  return (
    <>
      <div className="common-settings-title slide-right-fade delay-2">
        <Typography variant="h3" component="h3" className="mt-4">
          Configure o padrão dos exercícios
        </Typography>
        <Typography variant="label" component="label">
          Essas configurações serão aplicadas para todos os exercícios, e você
          poderá alterá-las individualmente após selecioná-los.
        </Typography>
      </div>
      <table className="common-settings mt-2  slide-right-fade delay-4">
        <tbody>
          {settings.map((setting, i) => (
            <tr key={i} className="common-setting">
              <td>
                <Typography variant="p" component="p">
                  {setting.name}
                </Typography>
              </td>
              <td>
                <Slider
                  aria-label={setting.name}
                  value={values[setting.key]}
                  step={setting.step}
                  min={setting.min}
                  color="secondary"
                  max={setting.max}
                  className="common-setting-slider"
                  onChange={(v) => {
                    handleUpdateCommonPattern(v.target.value, setting.key);
                  }}
                />
              </td>
              <td>
                <Typography variant="p" component="p">
                  {Conf.commonPatterns[setting.key]}
                </Typography>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
};

const WorkoutValidUntilArea = () => {
  const [active, setActive] = useState(false);

  const [validUntil, setValidUntil] = useState();
  const [validityType, setValidityType] = useState("QTD");

  const REF_configured = useRef(false);

  useEffect(() => {
    if (!REF_configured.current) {
      REF_configured.current = true;

      Conf.onLoadedWorkout(() => {
        setValidityType(Conf.workout.validityType || "QTD");
        setValidUntil(Conf.workout.validUntil);
      });
    }
  }, []);

  useEffect(() => {
    Conf.workout.validityType = validityType;
  }, [validityType]);
  useEffect(() => {
    Conf.workout.validUntil = validUntil;
  }, [validUntil]);

  useEffect(() => {
    if (!active) {
      setValidityType(undefined);
      setValidUntil(undefined);
    } else {
      setValidityType("QTD");
      setValidUntil(45);
    }
  }, [active]);

  function handleQtdInput(v) {
    let value = v.target.value;
    value = value.replace(/\D/g, "");
    console.log(value);
    setValidUntil(value);
  }

  return (
    <div className="mt-4 workout-validity-area">
      <Typography variant="h3">Validade da ficha de treino</Typography>
      <div className="mt-2">
        <Switch
          checked={active}
          onChange={(e) => {
            setTimeout(() => {
              setValidUntil(e.target.checked ? 45 : "");
            }, 1);
            setActive(e.target.checked);
          }}
          color="secondary"
          inputProps={{ "aria-label": "controlled" }}
          className="mr-2"
        />
        <Typography variant="p">Até completar</Typography>
        <TextField
          disabled={!active}
          sx={{ width: 70 }}
          inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
          color="secondary"
          className="mx-2"
          variant="filled"
          onInput={handleQtdInput}
          value={validUntil}
        />
        <Select
          disabled={!active}
          value={validityType}
          onChange={(e) => {
            setValidityType(e.target.value);
          }}
          color="secondary"
          variant="filled"
          size="small"
          sx={{ minWidth: 90 }}
        >
          <MenuItem value="QTD">treinos</MenuItem>
          <MenuItem value="DATE">dias</MenuItem>
        </Select>
      </div>
    </div>
  );
};

const WorkoutDaysTab = ({ handleAddTab, handleRemoveTab }) => {
  const rows = [];

  const [workoutDays, setWorkoutDays] = useState([]);
  const [currentTab, setCurrentTab] = useState(0);

  const REF_configured = useRef();

  useEffect(() => {
    if (!REF_configured.current) {
      REF_configured.current = true;
      setWorkoutDays([...Conf.workout.exercises_for_each_day]);
      Conf.onTabAdded(updateWorkoutDays);
      Conf.onLoadedWorkout(updateWorkoutDays);
      Conf.onTabChange((v) => setCurrentTab(v));
      Conf.onTabRemove(updateWorkoutDays);
    }
  }, []);

  function updateWorkoutDays() {
    setWorkoutDays([...Conf.workout.exercises_for_each_day]);
  }

  for (let i = 0; i < workoutDays.length; i++) {
    rows.push(
      <div
        className={"tab-area " + (currentTab === i ? " selected-tab" : "")}
        key={i}
      >
        <button
          onClick={() => Conf.triggerTabChange(i)}
          className="tab"
          key={i}
        >
          <Typography
            variant="h4"
            component="h4"
            className={(currentTab === i ? "current-tab " : "") + " tab-title"}
          >
            Dia {i + 1}
          </Typography>
        </button>
        {workoutDays.length > 1 && (
          <button
            className="close-tab-button"
            onClick={() => {
              const confirmText =
                "Atenção, realmente deseja excluir o dia " + (i + 1) + "?";
              if (window.confirm(confirmText) == true) {
                Conf.triggerTabRemove(i);
              }
            }}
          >
            <CloseIcon />
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="workout-days-tab  select-day   mt-6 px-2">
      {rows}
      <button
        disabled={workoutDays.length >= 7}
        className="add-tab-button"
        onClick={Conf.triggerAddTab}
      >
        <AddIcon />
      </button>
    </div>
  );
};

const SelectExercises = ({ exercisesAvailable, setExercisesAvailable }) => {
  const [chipFilters, setChipFilters] = useState([
    { name: "Peitoral", active: true },
    { name: "Quadríceps", active: true },
    { name: "Abdominal", active: true },
    { name: "Glúteos", active: true },
    { name: "Isquiotibiais", active: true },
    { name: "Panturrilha", active: true },
    { name: "Costas", active: true },
    { name: "Tríceps", active: true },
    { name: "Bíceps", active: true },
    { name: "Ombro", active: true },
    { name: "Antebraço", active: true },
    { name: "Abdutores", active: true },
    { name: "Adutores", active: true },
    { name: "Iliopsoas", active: true },
    { name: "Pé", active: true },
  ]);
  const [exercisesInputFilter, setExercisesInputFilter] = useState("");
  const [exerciseTypeFilter, setExerciseTypeFilter] = useState("exercise");
  const [anchorEl, setAnchorEl] = useState(null);
  const [gifToDisplay, setGifToDisplay] = useState();

  const exercisesRef = useRef();

  useEffect(() => {
    const clonedExercises = [...exercisesAvailable];

    const activeChips = chipFilters
      .filter((chip) => chip.active === true)
      ?.map((muscle) => muscle.name);

    let newExercises = clonedExercises.map((exercise) => {
      const muscles = exercise?.MuscleGroups;
      exercise.displayInSelectFilter =
        exerciseHasMuscleGroupsFiltered(muscles) &&
        exercise.ExerciseName.toLowerCase().includes(
          exercisesInputFilter.toLowerCase()
        );
      return exercise;
    });

    setExercisesAvailable([...newExercises]);
  }, [chipFilters, exercisesInputFilter]);

  function exerciseHasMuscleGroupsFiltered(exerciseMuscleGroups) {
    if (!exerciseMuscleGroups) return false;
    const activeChips = chipFilters
      .filter((chip) => chip.active === true)
      ?.map((muscle) => muscle.name);
    let hasMuscleGroupSelected = false;
    exerciseMuscleGroups.forEach((muscle) => {
      if (activeChips.includes(muscle)) hasMuscleGroupSelected = true;
    });
    return hasMuscleGroupSelected;
  }
  function handlePressedChip(e, pressedItem) {
    const clonedChips = [...chipFilters];
    const allItemsActive = clonedChips.filter((chip) => chip.active).length > 1;

    if (allItemsActive) {
      clonedChips.map((chip) => (chip.active = false));
      clonedChips[pressedItem].active = true;
    } else {
      clonedChips.map(
        (chip) => (chip.active = clonedChips[pressedItem].active)
      );
      clonedChips[pressedItem].active = true;
    }

    setChipFilters(clonedChips);
  }
  function handleClickOnExercise(clickedExercise) {
    Conf.workout.exercises_for_each_day[Conf.currentTab].push({
      ...clickedExercise,
      repetitions: Conf.commonPatterns.repetitions,
      series: Conf.commonPatterns.series,
      restTime: Conf.commonPatterns.restTime,
    });

    Conf.triggerExerciseListChange();
  }
  function handleDisplayExercisePreview(banner, isVideo = false) {
    const media = isVideo
      ? banner
      : banner.replace("banners", "tutorials").slice(0, -3) + "gif";
    const mediaData = { media, isVideo };
    setGifToDisplay({ ...mediaData });
    setTimeout(() => {
      setAnchorEl(exercisesRef.current);
    }, 10);
  }
  function ReactionsBar(data) {
    const reactions = data.reactions;
    const hasLike = !!data.reactions?.filter(
      (reaction) => reaction.reactionType === "LIKE"
    )[0];
    const hasDislike = !!data.reactions?.filter(
      (reaction) => reaction.reactionType === "DISLIKE"
    )[0];
    const lastComment = data.reactions?.filter(
      (reaction) => reaction.reactionType === "COMMENT"
    )[0]?.payload;

    const reactionsList = [
      {
        condition: hasLike,
        title: "O aluno gosta deste exercício",
        icon: <ThumbUpIcon className="reaction-icon" />,
      },
      {
        condition: hasDislike,
        title: "O aluno não gostou deste exercício",
        icon: <ThumbDownIcon className="reaction-icon" />,
      },
      {
        condition: !!lastComment,
        title: "Comentário do aluno: " + lastComment,
        icon: <MarkUnreadChatAltIcon className="reaction-icon" />,
      },
    ];

    return (
      <>
        {reactionsList.map((reaction) => {
          if (!reaction.condition) return null;
          return (
            <Tooltip
              disableInteractive
              arrow
              title={reaction.title}
              placement="top"
            >
              {reaction.icon}
            </Tooltip>
          );
        })}
      </>
    );
  }
  function exercise(data, index) {
    return (
      <div style={{ position: "relative" }}>
        <button
          key={data.key}
          className={"exercise-card"}
          onClick={() => handleClickOnExercise(data)}
        >
          <div className="exercise-card-play-btn">
            <img src={data.BannerURL} className="banner-exercise" />
            <div className="exercise-play-btn">
              <IconButton
                onMouseOver={(e) => {
                  e.stopPropagation();
                  if (data.isCustomExercise) {
                    handleDisplayExercisePreview(data.BannerURL, true);
                  } else {
                    handleDisplayExercisePreview(data.BannerURL);
                  }
                }}
                onMouseOut={() => setGifToDisplay(null)}
              >
                <PlayArrowIcon style={{ color: "white" }} />
              </IconButton>
            </div>
          </div>
          <div className="exercise-info">
            <div className="exercise-info-title-area">
              <ReactionsBar data={data} />
              <Tooltip
                disableInteractive
                arrow
                title={data.ExerciseName}
                placement="top"
              >
                <Typography
                  variant="p"
                  component="p"
                  className="exercise-title"
                >
                  {data.ExerciseName}
                </Typography>
              </Tooltip>
            </div>
            <div className="muscle-groups-area">
              {data.MuscleGroups.map((muscleGroup, i) => (
                <Chip key={i + 1} size="small" label={muscleGroup} />
              ))}
            </div>
          </div>
          <div className="add-exercise-button">
            <AddIcon />
          </div>
        </button>
        <Divider />
      </div>
    );
  }

  return (
    <>
      <div className="exercises-select-area">
        <Typography
          variant="h3"
          component="h3"
          className="animate__animated animate__faster animate__fadeInLeft"
        >
          Selecionar os exercícios
        </Typography>

        <TextField
          fullWidth
          size="medium"
          color="secondary"
          label="Buscar exercício"
          className="mt-2 mb-2"
          onInput={(e) => setExercisesInputFilter(e.target.value)}
          variant="outlined"
        />

        <div className="workout-days-tab">
          <div
            className={
              "tab-area" +
              (exerciseTypeFilter === "exercise" ? " selected-tab" : "")
            }
          >
            <button
              onClick={() => setExerciseTypeFilter("exercise")}
              className="tab"
            >
              <Typography
                variant="h5"
                component="h5"
                className={
                  (exerciseTypeFilter === "exercise" ? "current-tab " : "") +
                  " tab-title"
                }
              >
                Exercícios
              </Typography>
            </button>
          </div>
          <div
            className={
              "tab-area" +
              (exerciseTypeFilter === "stretching" ? " selected-tab" : "")
            }
          >
            <button
              onClick={() => setExerciseTypeFilter("stretching")}
              className="tab"
            >
              <Typography
                variant="h5"
                component="h5"
                className={
                  (exerciseTypeFilter === "stretching" ? "current-tab " : "") +
                  " tab-title"
                }
              >
                Alongamentos
              </Typography>
            </button>
          </div>
        </div>

        <Typography variant="p" component="p" className="mt-2 fade">
          Filtrar por grupos musculares:
        </Typography>

        <div className="filter-chips mt-1 mb-2" id="chips-area">
          <div className="chips-slider">
            {chipFilters.map((chip, i) => (
              <Chip
                className={
                  "chip-filter fade px-1 " + (chip.active ? "active" : "")
                }
                onClick={(e) => handlePressedChip(e, i)}
                style={{ animationDelay: `${i / 10}s` }}
                label={
                  <Typography
                    style={{ cursor: "pointer" }}
                    variant="label"
                    component="label"
                  >
                    {chip.name}
                  </Typography>
                }
                key={i}
                variant={chip.active ? "filled" : "outlined"}
                size="small"
              />
            ))}
          </div>
        </div>

        <div className="exercises-area" ref={exercisesRef}>
          {exercisesAvailable
            .filter((exercise) => {
              if (exerciseTypeFilter === "stretching")
                return exercise.IsStretching;
              return !exercise.IsStretching;
            })
            .map((exerciseData, i) => {
              if (exerciseData?.displayInSelectFilter)
                return (
                  <div
                    key={i}
                    style={{ animationDelay: `0.1s` }}
                    className="fade"
                  >
                    {exercise(exerciseData, i)}
                  </div>
                );
              else return <></>;
            })}
        </div>

        {anchorEl && (
          <Popper
            key={Math.random()}
            placement="right"
            open={!!gifToDisplay?.media}
            anchorEl={anchorEl}
            onClose={() => setAnchorEl(null)}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            style={{ zIndex: 77 }}
          >
            <div className="gif-popper">
              <LogoSVG className="gif-popper-watermark" />
              <img src={gifToDisplay?.media} />
            </div>
          </Popper>
        )}
      </div>
    </>
  );
};

const ConfigureExercises = ({ handleClickOnAddComment }) => {
  const exercises = Conf.getCurrentTabExercises();
  const [items, setItems] = useState(exercises);
  const [isDragging, setIsDragging] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isAGroupBeingDragged, setIsAGroupBeingDragged] = useState(false);

  const currentInput = useRef();

  const REF_configured = useRef(false);
  const REF_isDraggingGroup = useRef(false);

  useEffect(() => {
    if (!REF_configured.current) {
      REF_configured.current = true;
      Conf.onLoadedWorkout(handleRefreshList);
      Conf.onExerciseListChange(handleRefreshList);
      Conf.onTabChange(handleRefreshList);
    }
  }, []);

  function handleRefreshList() {
    setItems([...Conf.getCurrentTabExercises()]);
  }

  function handleReorderExercises(newOrder) {
    Conf.workout.exercises_for_each_day[Conf.currentTab] = [...newOrder];
  }
  function handleRemoveExercise(exerciseIndex, groupIndex = null) {
    const workoutDayClone = [...exercises];

    if (groupIndex === null) {
      workoutDayClone.splice(exerciseIndex, 1);
    } else {
      workoutDayClone[groupIndex].exercises.splice(exerciseIndex, 1);
    }

    handleReorderExercises(workoutDayClone);
    handleRefreshList();
  }
  function updateParameter(value, exerciseIndex, parameter, groupIndex = null) {
    const exercisesClone = [...exercises];

    if (groupIndex === null) {
      exercisesClone[exerciseIndex] = {
        ...exercisesClone[exerciseIndex],
        [parameter]: parseInt(value),
      };
    } else {
      exercisesClone[groupIndex].exercises[exerciseIndex] = {
        ...exercisesClone[groupIndex].exercises[exerciseIndex],
        [parameter]: parseInt(value),
      };
    }

    handleReorderExercises(exercisesClone);
    handleRefreshList();
  }

  function onDragEnd(result) {
    if (REF_isDraggingGroup.current) {
      REF_isDraggingGroup.current = false;
      Conf.triggerSnackbar(
        "Não é possível adicionar um grupo dentro de outro grupo"
      );
      handleRefreshList();
      return;
    }

    REF_isDraggingGroup.current = false;

    if (!result.destination) {
      return;
    }

    let newItems = [...items];

    const sourceId = result.source.droppableId;
    const destinationId = result.destination.droppableId;

    //Foi arrastado para algum grupo de exercícios
    if (destinationId.split("-")[0] === "group") {
      const destinationGroupIndex = parseInt(destinationId.split("-")[1]);
      const sourceGroupIndex = parseInt(sourceId.split("-")[1]);

      //Veio de fora de um grupo
      if (sourceId === "non-group") {
        const [exerciseInfo] = [...newItems].splice(result.source.index, 1);
        newItems[destinationGroupIndex].exercises.splice(
          result.destination.index,
          0,
          exerciseInfo
        );
        newItems.splice(result.source.index, 1);
      } else {
        if (result.destination.droppableId === result.source.droppableId) {
          const [removed] = newItems[destinationGroupIndex].exercises.splice(
            result.source.index,
            1
          );
          newItems[destinationGroupIndex].exercises.splice(
            result.destination.index,
            0,
            removed
          );
        } else {
          const [exerciseInfo] = [...newItems][
            sourceGroupIndex
          ].exercises.splice(result.source.index, 1);
          newItems[destinationGroupIndex].exercises.splice(
            result.destination.index,
            0,
            exerciseInfo
          );
        }
      }
    } else {
      if (sourceId === "non-group") {
        const [removed] = newItems.splice(result.source.index, 1);
        newItems.splice(result.destination.index, 0, removed);
      } else {
        const sourceGroupIndex = parseInt(sourceId.split("-")[1]);
        const [exerciseInfo] = [...newItems][sourceGroupIndex].exercises.splice(
          result.source.index,
          1
        );
        newItems.splice(result.destination.index, 0, exerciseInfo);
      }
    }

    currentInput.current?.blur();
    setItems([...newItems]);
    handleReorderExercises(newItems);
  }
  function handleDuplicateExercise(exerciseData, index, groupIndex = null) {
    const itemsCopy = [...items];

    if (groupIndex !== null) {
      itemsCopy[groupIndex].exercises.splice(index + 1, 0, {
        ...exerciseData,
        comment: null,
      });
    } else {
      itemsCopy.splice(index + 1, 0, { ...exerciseData, comment: null });
    }
    setItems([...itemsCopy]);
    handleReorderExercises(itemsCopy);
  }
  function Exercise({ config, exerciseIndex, groupIndex = null }) {
    const [tmpRepetitions, setTmpRepetitions] = useState(config.repetitions);
    const [tmpRestTime, setTmpRestTime] = useState(config.restTime);
    const [tmpSeries, setTmpSeries] = useState(config.series);

    function parseIntValue(v) {
      if (!v) v = 0;
      v = `${v}`;
      v = v.replace(/[^0-9]/g, "");
      return parseInt(v);
    }

    return (
      <div
        className={"exercise-config-row "}
        style={{ animationDelay: `${exerciseIndex / 12}s` }}
        key={exerciseIndex}
        id={"exercise-row-" + exerciseIndex + "-" + groupIndex}
        onMouseDown={() => {
          currentInput.current?.blur();
        }}
      >
        <Tooltip
          title={config.ExerciseName}
          disableInteractive
          placement="top"
          arrow
        >
          <Typography
            variant="h5"
            component="h5"
            style={{
              flex: 1,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {config.ExerciseName}
          </Typography>
        </Tooltip>
        <div
          style={{ minWidth: 0, display: "flex", alignItems: "center" }}
          className="exercise-reorder-row-content"
        >
          <TextField
            fullWidth
            className="exercise-config-cell input-cell"
            size="small"
            color="secondary"
            label={
              config.ExerciseType === "RESISTENCE" ? "tempo (s)" : "repetições"
            }
            id={"exercise-repetitions-" + exerciseIndex}
            onBlur={(e) => {
              currentInput.current = null;
              updateParameter(
                e.target.value,
                exerciseIndex,
                "repetitions",
                groupIndex
              );
            }}
            onFocus={(e) => {
              currentInput.current = e.target;
            }}
            onInput={(e) => {
              e.stopPropagation();
              setTmpRepetitions(parseIntValue(e.target.value));
            }}
            value={tmpRepetitions}
            variant="standard"
          />
          <TextField
            fullWidth
            className="exercise-config-cell input-cell"
            size="small"
            color="secondary"
            label="descanso (s)"
            onBlur={(e) => {
              currentInput.current = null;
              updateParameter(
                e.target.value,
                exerciseIndex,
                "restTime",
                groupIndex
              );
            }}
            onFocus={(e) => {
              currentInput.current = e.target;
            }}
            onInput={(e) => setTmpRestTime(parseIntValue(e.target.value))}
            id={"exercise-restTime-" + exerciseIndex}
            variant="standard"
            value={tmpRestTime}
          />
          <TextField
            fullWidth
            className="exercise-config-cell input-cell"
            size="small"
            color="secondary"
            id={"exercise-series-" + exerciseIndex}
            label="series"
            onBlur={(e) => {
              currentInput.current = null;
              updateParameter(
                e.target.value,
                exerciseIndex,
                "series",
                groupIndex
              );
            }}
            onFocus={(e) => {
              currentInput.current = e.target;
            }}
            onInput={(e) => setTmpSeries(parseIntValue(e.target.value))}
            variant="standard"
            value={tmpSeries}
          />
          <div className="config-row-buttons pl-2">
            <Tooltip disableInteractive title="Duplicar" placement="top" arrow>
              <IconButton
                onMouseUp={(e) => {
                  currentInput.current?.blur();
                  setTimeout(() => {
                    handleDuplicateExercise(
                      config,
                      exerciseIndex,
                      groupIndex,
                      groupIndex
                    );
                  }, 1);
                }}
              >
                <ContentCopyIcon />
              </IconButton>
            </Tooltip>
            <Tooltip
              disableInteractive
              title="Adicionar / editar comentário"
              placement="top"
              arrow
            >
              <IconButton
                onMouseUp={() => {
                  currentInput.current?.blur();
                  setTimeout(() => {
                    handleClickOnAddComment(exerciseIndex, groupIndex);
                  }, 1);
                }}
              >
                <MarkUnreadChatAltIcon
                  color={!!config.comment ? "secondary" : "currentColor"}
                />
              </IconButton>
            </Tooltip>
            <Tooltip
              disableInteractive
              title="Remover exercício"
              placement="top"
              arrow
            >
              <IconButton
                onMouseUp={() => {
                  currentInput.current?.blur();
                  setTimeout(() => {
                    handleRemoveExercise(exerciseIndex, groupIndex);
                  }, 1);
                }}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
            <Tooltip
              disableInteractive
              title="Mova o exercício para a posição desejada"
              placement="top"
              arrow
            >
              <IconButton
                className="drag-indicator"
                onMouseDown={() => {
                  currentInput.current?.blur();
                }}
              >
                <DragIndicatorIcon />
              </IconButton>
            </Tooltip>
          </div>
        </div>
      </div>
    );
  }
  function exercisesGroup(item, index) {
    function handleToggleCollapse() {
      const itemsCopy = [...items];
      itemsCopy[index].isCollapsed = !itemsCopy[index].isCollapsed;
      setItems([...itemsCopy]);
      handleReorderExercises(itemsCopy);
    }
    return (
      <Droppable
        key={index}
        isDropDisabled={isAGroupBeingDragged}
        droppableId={`group-${index}`}
        direction="vertical"
      >
        {(provided, snapshot) => (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            className={
              snapshot.isDraggingOver
                ? "exercises-group-container dragging-over"
                : "exercises-group-container"
            }
          >
            <>
              <Tooltip title="Remover grupo de exercícios">
                <IconButton
                  onClick={() => handleRemoveExercise(index)}
                  className="delete-group-btn"
                >
                  <CloseIcon />
                </IconButton>
              </Tooltip>
              <div className="exercise-group-title-area">
                <Typography component="h4" variant="h4">
                  Grupo de exercícios
                </Typography>
                <IconButton onClick={handleToggleCollapse} size="small">
                  {item.isCollapsed ? (
                    <ArrowDropUpIcon />
                  ) : (
                    <ArrowDropDownIcon />
                  )}
                </IconButton>
              </div>
              {item.isCollapsed && (
                <div className="collapsed-exercises">
                  {[...new Set(item.exercises.map((e) => e.ExerciseName))].map(
                    (data) => (
                      <Typography
                        variant="small"
                        className="exercise-name-preview"
                      >
                        {data}{" "}
                      </Typography>
                    )
                  )}
                </div>
              )}
              {!item.isCollapsed &&
                item.exercises.map((exerciseData, exerciseIndex) => (
                  <DraggableComponent
                    draggableId={`groupexercise-${index}-${exerciseIndex}`}
                    index={exerciseIndex}
                    key={exerciseIndex}
                  >
                    {(provided, snapshot) => {
                      if (snapshot.isDragging) {
                        provided.draggableProps.style.left =
                          provided.draggableProps.style.offsetLeft;
                        provided.draggableProps.style.top =
                          provided.draggableProps.style.offsetTop;
                      }
                      var transform = provided.draggableProps.style.transform;
                      if (transform) {
                        var t = transform.split(",")[1];
                        provided.draggableProps.style.transform =
                          "translate(0px," + t;
                      }
                      return (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={{
                            ...provided.draggableProps.style,
                            marginLeft: 20,
                          }}
                          className="dragable-row"
                        >
                          <Exercise
                            config={exerciseData}
                            exerciseIndex={exerciseIndex}
                            groupIndex={index}
                          />
                        </div>
                      );
                    }}
                  </DraggableComponent>
                ))}
              {provided.placeholder}
            </>
          </div>
        )}
      </Droppable>
    );
  }

  return (
    <div className="configure-exercises" key={Math.random()}>
      {items?.length > 0 ? (
        <>
          <Typography variant="h3" component="h3" className="mb-4">
            Configuração dos exercícios
          </Typography>
          <DragDropContext
            onDragStart={(e) => {
              if (e.draggableId.split("-")[0] === "group")
                REF_isDraggingGroup.current = true;
            }}
            onDragEnd={onDragEnd}
          >
            <Droppable droppableId="non-group" direction="vertical">
              {(provided, snapshot) => (
                <div {...provided.droppableProps} ref={provided.innerRef}>
                  {items.map((item, index) => {
                    return (
                      <DraggableComponent
                        draggableId={`${
                          item.isGroup ? "group-" : item.ExerciseID
                        }-${index}`}
                        index={index}
                        key={index}
                      >
                        {(provided, snapshot) => {
                          var transform =
                            provided.draggableProps.style.transform;
                          if (transform) {
                            var t = transform.split(",")[1];
                            const scale =
                              snapshot?.draggingOver?.split("-")[0] === "group"
                                ? "scale(0.92)"
                                : "scale(1)";
                            provided.draggableProps.style.transform =
                              scale + " translate(0px," + t;
                            provided.draggableProps.style.transition =
                              "0.15s ease";
                          }
                          return (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              style={{
                                ...provided.draggableProps.style,
                              }}
                              {...provided.dragHandleProps}
                            >
                              {item.isGroup ? (
                                exercisesGroup(item, index)
                              ) : (
                                <Exercise config={item} exerciseIndex={index} />
                              )}
                            </div>
                          );
                        }}
                      </DraggableComponent>
                    );
                  })}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
          <Button
            variant="contained"
            style={{
              width: "fit-content",
              margin: "20px auto 0 auto",
              padding: "6px 20px",
            }}
            onClick={() => {
              const itemsCopy = [...items];
              itemsCopy.push({ isGroup: true, exercises: [] });
              setItems([...itemsCopy]);
              handleReorderExercises(itemsCopy);
            }}
          >
            Adicionar grupo de exercícios
          </Button>
        </>
      ) : (
        <div className="select-items-alert mt-8">
          <Typography variant="h3" component="h3">
            Selecione os exercícios ao lado, e depois os configure aqui
          </Typography>
          <SelectItemsSVG className="select-items-svg" />
        </div>
      )}
    </div>
  );
};

const ModalAddComment = ({
  open,
  handleAddComment,
  setOpen,
  existingComment,
}) => {
  const [fixedComments, setFixedComments] = useState(handleLoadSuggestions());
  const [comment, setComment] = useState(existingComment || "");

  const dragRef = useRef();

  const Suggestion = ({ text, index }) => (
    <div className="suggested-comment">
      <Tooltip arrow title="Remover sugestão">
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            handleRemoveSuggestion(index);
          }}
          className="suggestion-pin-btn"
        >
          <PushPinIcon />
        </IconButton>
      </Tooltip>
      <Typography variant="small">{text}</Typography>
      <Divider />
      <Button
        onClick={(e) => setComment(text)}
        size="small"
        style={{ padding: 1 }}
        color="secondary"
      >
        Aplicar
      </Button>
    </div>
  );

  function handleDrag(e, data) {
    const element = e.target;
    const scrollAmount = data.deltaX;
    element.scrollLeft -= scrollAmount;
  }
  function handleLoadSuggestions() {
    const storaged = localStorage.getItem("FixedComments");
    if (!storaged) {
      const suggested = [
        "Aumentar a carga a cada série",
        "Reduzir a carga a cada série",
        "Segurar a repetição por 2s no pico de contração",
      ];
      localStorage.setItem("FixedComments", JSON.stringify(suggested));
      return suggested;
    }
    return JSON.parse(storaged);
  }
  function handleRemoveSuggestion(index) {
    const newSuggestionList = [...fixedComments];
    newSuggestionList.splice(index, 1);
    localStorage.setItem("FixedComments", JSON.stringify(newSuggestionList));
    setFixedComments([...newSuggestionList]);
  }
  function handleAddSuggestion() {
    const newSuggestionList = [comment, ...fixedComments];
    localStorage.setItem("FixedComments", JSON.stringify(newSuggestionList));
    setFixedComments([...newSuggestionList]);
  }

  return (
    <CustomModal
      maxWidth={520}
      bottomButtonSumbitText="Adicionar comentário"
      bottomButtonSumbitIcon={null}
      title="Comentário do exercício"
      handleSubmit={() => handleAddComment(comment)}
      open={open}
      handleClose={() => setOpen(false)}
      bodyComponent={
        <div className="add-comment-modal">
          <Alert severity="info">
            <Typography variant="small">
              Este comentário será mostrado ao aluno quando ele estiver
              executando este exercício
            </Typography>
          </Alert>

          <Typography variant="h4" className="mt-4 mb-1">
            Usar comentário fixado
          </Typography>

          <div
            style={{ overflowX: "scroll", maxWidth: 456 }}
            className="suggested-comments-list py-0"
          >
            <Draggable axis="x" onDrag={handleDrag}>
              <div className="suggested-comments-list py-1" ref={dragRef}>
                {fixedComments.map((suggestedComment, i) => (
                  <Suggestion text={suggestedComment} index={i} key={i} />
                ))}
              </div>
            </Draggable>
          </div>

          <TextField
            InputProps={{
              endAdornment: comment.length > 0 && (
                <Tooltip arrow title="Salvar como comentário fixado">
                  <IconButton
                    small
                    onClick={(e) => {
                      e.stopPropagation();
                      handleAddSuggestion();
                    }}
                  >
                    <PushPinIcon />
                  </IconButton>
                </Tooltip>
              ),
            }}
            fullWidth
            className="mt-3"
            label="Digite um comentário"
            color="secondary"
            type="text"
            value={comment}
            error={comment.length > 100}
            onInput={(e) =>
              e.target.value.length <= 100 && setComment(e.target.value)
            }
          />
          <Typography
            component="h5"
            className="mb-3 mt-1"
            style={{ textAlign: "right", flexGrow: 1, width: "100%" }}
            color={comment.length > 100 ? "error" : "primary"}
          >
            {comment.length}/100
          </Typography>
        </div>
      }
    />
  );
};
